import React from 'react';
import { ClipLoader } from 'react-spinners';

type LoadingProps = {
  color?: string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
};

const Loading: React.FC<LoadingProps> = ({
  color = '#fff',
  size = 50,
  style = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}) => {
  return (
    <div style={style}>
      <ClipLoader color={color} size={size} />
    </div>
  );
};

export default Loading;
